export default __webpack_public_path__ + "static/media/g9.a01b511b.jpg";